export default __webpack_public_path__ + "static/DanzzaBold-020fd8a2b8b2d4c89b2c9989c00ec382.woff2";